/**
 * Transform utilities for converting form data to API format
 * These functions convert form component data structures to the unified CreateRegistration API format
 * Core user fields (firstName, lastName, email) are extracted to top level per API spec
 */
import { EVENT_ID } from '../shared/constants';
/**
 * Extract email from form data, checking multiple possible field names
 */
const getEmail = (formData) => {
    return (formData.email || formData.registrantEmail || formData.schoolEmail || '');
};
/**
 * Transform helper - converts IndependentRegistrationData from form format to API format
 * @param formData - Form data from IndependentRegistration component (FormValues)
 * @returns CreateRegistration with registrationType: 'independent'
 */
export function transformIndependentRegistrationData(formData) {
    return {
        eventId: EVENT_ID,
        registrationType: 'independent',
        firstName: (formData.firstName || ''),
        lastName: (formData.lastName || ''),
        email: getEmail(formData),
        eventData: {
            ...formData,
            acceptedTerms: true, // Ensure acceptedTerms is always true
        },
    };
}
/**
 * Transform helper - converts SchoolRegistrationData from form format to API format
 * @param formData - Form data from SchoolRegistration component (FormValues)
 * @returns CreateRegistration with registrationType: 'school'
 */
export function transformSchoolRegistrationData(formData) {
    return {
        eventId: EVENT_ID,
        registrationType: 'school',
        firstName: (formData.firstName || ''),
        lastName: (formData.lastName || ''),
        email: getEmail(formData),
        schoolId: formData.schoolId,
        eventData: {
            ...formData,
            acceptedTerms: true, // Ensure acceptedTerms is always true
        },
    };
}
/**
 * Transform helper - converts CommunityRegistrationData from form format to API format
 * @param formData - Form data from CommunityRegistration component (FormValues)
 * @returns CreateRegistration with registrationType: 'community'
 */
export function transformCommunityRegistrationData(formData) {
    return {
        eventId: EVENT_ID,
        registrationType: 'community',
        firstName: (formData.firstName || ''),
        lastName: (formData.lastName || ''),
        email: getEmail(formData),
        eventData: {
            ...formData,
            acceptedTerms: true, // Ensure acceptedTerms is always true
        },
    };
}
